import { TransactionsDateFilterState } from './TransactionsDateFilterState';
import { Transaction } from '../../types/Transaction';
import { useContext, useEffect } from 'react';
import { AdminTableContext } from '../../../components/table/contexts/AdminTableContext';
import { FilterFn } from '../../../components/table/interfaces/FilterFn';

export function useTransactionsDateSetFilterFunction(
  changed: boolean,
  state: TransactionsDateFilterState,
  filterFn: FilterFn<Transaction, TransactionsDateFilterState>,
) {
  const { setFilterFunctions } = useContext(AdminTableContext);

  useEffect(() => {
    if (changed) {
      const fn = (item: Transaction) => filterFn(item, state);

      setFilterFunctions((items) => items.concat(fn));

      return () => {
        setFilterFunctions((items) => items.filter((item) => item !== fn));
      };
    }
  }, [changed, state, filterFn, setFilterFunctions]);
}
